import * as onnx from "onnxruntime-web";

const modelFile = `${process.env.PUBLIC_URL}/recall_forgetting_curve_model.onnx`;

let pendingSession = null;

export const loadForgettingCurveSession = () => {
  if (!pendingSession) {
    pendingSession = onnx.InferenceSession.create(modelFile);
  }

  return pendingSession;
};

export default loadForgettingCurveSession;
